module.exports = __webpack_public_path__ + "static/media/gc-beach-good.bb82bbcd.png";